
<template>
  <Headbar v-if="isLoggedIn"></Headbar>
  <keep-alive>
    <router-view/>
  </keep-alive>
  
  <Tabbar v-if="isLoggedIn"></Tabbar>
  <div class="footer">
    
    <a href="https://beian.miit.gov.cn" target="_blank">湘ICP备2025108019号-1</a>
    </div>
</template>
<script>
  import { mapState } from 'vuex';  
  import Headbar from '@/view/Headbar';
  import Tabbar from '@/view/Tabbar.vue';
export default {
  name: 'app',
  components: {
    Headbar,
    Tabbar,
  },
    computed: {
    ...mapState(['isLoggedIn']),
  },
}
</script>
<style>
.footer {
            position: fixed;
            bottom: 0;
            width: 100%;
            background-color: #f1f1f1;
            text-align: center;
            padding: 10px 0;
        }
        .beian {
            color: #333;
            text-decoration: none;
        }
</style>

<style scoped lang="less">
#app {
  max-width: 100vw; /* Ensure the app doesn't exceed viewport width */  
    overflow: hidden;  /* Prevent overflow */  
  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #323233;
  font-size: 18px;
}
.headbar{
  left: 0;
  right: 0;
  position: fixed;
  height: 40px;
} 
 nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style> 
